module.exports = {
    rule: {
        // 姓名
        name: (rule, value, callback) => {
            if (!value) return callback(new Error('姓名不能为空'));
            callback();
        },
        // 汉语拼音
        nameSpell: (rule, value, callback) => {
            if (!value) return callback(new Error('汉语拼音不能为空'));
            callback();
        },
        // 民族
        nation: (rule, value, callback) => {
            if (!value) return callback(new Error('民族不能为空'));
            callback()
        },
        // 性别
        gender: (rule, value, callback) => {
            if (!value && value !== 0) return callback(new Error('性别不能为空'));
            callback();
        },
        // 政治面貌
        political: (rule, value, callback) => {
            if (!value) return callback(new Error('政治面貌不能为空'));
            callback();
        },
        // 出生年月
        birthday: (rule, value, callback) => {
            if (!value) return callback(new Error('出生年月不能为空'));
            callback();
        },
        // 批准时间
        approvalTime: (rule, value, callback) => {
            if (!value) return callback(new Error('批准时间不能为空'));
            callback();
        },
        // 身高
        height: (rule, value, callback) => {
            if (!value) return callback(new Error('身高不能为空'));
            if (value > 300) return callback(new Error('身高不能超过3米'));
            if (!/(^[1-9]{1}[0-9]*$)|(^[0-9]*\.[0-9]{1}$)/.test(value)) return callback(new Error('输入正整数或保留一位小数'));
            callback();
        },
        // 体重
        weight: (rule, value, callback) => {
            if (!value) return callback(new Error('体重不能为空'));
            if (value > 200) return callback(new Error('体重不能超过200kg'));
            if (!/(^[1-9]{1}[0-9]*$)|(^[0-9]*\.[0-9]{1,2}$)/.test(value)) return callback(new Error('输入正整数或保留两位小数'));
            callback();
        },
        // 身高（非必填）
        notRequireHeight(rule, value, callback) {
            if (value < 100 && value > 0) return callback(new Error("身高输入错误"));
            if (value > 300) return callback(new Error('身高不能超过3米'));
            if (!/(^[1-9]{1}[0-9]*$)|(^[0-9]*\.[0-9]{1}$)/.test(value) && value) return callback(new Error('输入正整数或保留一位小数'));
            callback();
        },
        // 体重（非必填）
        notRequireWeight(rule, value, callback) {
            if (value < 30 && value > 0) return callback(new Error("体重输入错误"));
            if (value > 200) return callback(new Error('体重不能超过200kg'));
            if (!/(^[1-9]{1}[0-9]*$)|(^[0-9]*\.[0-9]{1,2}$)/.test(value) && value) return callback(new Error('输入正整数或保留两位小数'));
            callback();
        },
        // 鞋码
        shoesSize: (rule, value, callback) => {
            if (!value) callback();
            if (value > 60) return callback(new Error('鞋码不能超过60码'));
            if (!/(^[1-9]{1}[0-9]*$)|(^[0-9]*\.[0-9]{1}$)/.test(value)) return callback(new Error('输入正整数或保留一位小数'));
            callback();
        },
        // 职称
        positional: (rule, value, callback) => {
            if (!value) return callback(new Error('职称不能为空'));
            callback();
        },
        // 学历
        education: (rule, value, callback) => {
            if (!value) return callback(new Error('学历不能为空'));
            callback();
        },
        // 学位
        academic: (rule, value, callback) => {
            if (!value) return callback(new Error('学位不能为空'));
            callback();
        },
        // 首次注册项目
        project: (rule, value, callback) => {
            if (!value) return callback(new Error('注册项目不能为空'));
            callback();
        },
        // 培训时间
        trainingTime: (rule, value, callback) => {
            if (!value) return callback(new Error('培训时间不能为空'));
            callback();
        },
        // 毕业学校
        school: (rule, value, callback) => {
            if (!value) return callback(new Error('毕业学校不能为空'));
            callback();
        },
        // 移动电话
        phone: (rule, value, callback) => {
            if (!value) return callback(new Error('移动电话不能为空'));
            if (!(/^1[3456789]\d{9}$/.test(value))) return callback(new Error('手机号格式错误'));
            callback();
        },
        // 身份证
        idCard: (rule, value, callback) => {
            if (!value) return callback(new Error('身份证号码不能为空'));
            if (!(/^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X|x)$/.test(value))) return callback(new Error('身份证格式错误'));
            callback();
        },
        // 结业证书号
        trainingCertificate: (rule, value, callback) => {
            if (!value) return callback(new Error('结业证书号不能为空'));
            callback();
        },
        // 通讯地址
        address: (rule, value, callback) => {
            if (!value) return callback(new Error('通讯地址不能为空'));
            callback();
        },
        // 邮箱(非必填)
        email: (rule, value, callback) => {
            if (value && !/^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/.test(value))
                return callback(new Error('邮箱格式错误'));
            callback();
        },
        // 邮箱（必填）
        mustEmail: (rule, value, callback) => {
            if (!value) return callback(new Error('邮箱不能为空'));
            if (value && !/^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/.test(value))
                return callback(new Error('邮箱格式错误'));
            callback();
        },
        // 主要制裁记录
        refereeRecord: (rule, value, callback) => {
            if (!value) return callback(new Error('主要执裁记录不能为空'));
            callback();
        }
    },
    method: {
        timeFormat(time, type = null, num) {
            var date = new Date(time); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
            var Y = date.getFullYear();
            var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
            var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate());
            var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
            var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
            var s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
            let str = "";

            if (!type) str = Y + '-' + M + '-' + D;
            else if (type === 'utf') str = Y + '年' + M + '月' + D + '日'
            else if (type === 'slash') str = Y + '/' + M + '/' + D;
            if (num) {
                str = str = Y + '-' + M + '-' + D + " " + h + m + s
            }
            return str
        }
    }
}